import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const LeadsOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M14.2 10.74c2.4.46 4.47-1.61 4.01-4.01a3.397 3.397 0 0 0-2.68-2.67 3.409 3.409 0 0 0-4.01 4.01 3.398 3.398 0 0 0 2.67 2.67h.01Zm.67-5.15a1.81 1.81 0 1 1 0 3.62 1.81 1.81 0 0 1 0-3.62ZM16.22 11.2h-2.45c-3.2 0-5.79 2.59-5.79 5.79v1.5c0 .84.68 1.52 1.52 1.52h10.99c.84 0 1.52-.68 1.52-1.52v-1.5c0-3.2-2.59-5.79-5.79-5.79Zm4.19 7.21H9.59v-1.42c0-2.31 1.88-4.19 4.19-4.19h2.45c2.31 0 4.19 1.88 4.19 4.19v1.42h-.01Z"
      fill={color}
    />
    <Path
      d="M8.43 5.26a3.036 3.036 0 0 0-3.57 3.57c.23 1.19 1.2 2.16 2.38 2.38 2.14.41 3.98-1.44 3.57-3.57-.23-1.19-1.2-2.16-2.38-2.38Zm-.59 4.41a1.44 1.44 0 1 1 0-2.88 1.44 1.44 0 0 1 0 2.88ZM7.56 11.85c-3.2 0-5.79 2.59-5.79 5.79v.85c0 .84.68 1.52 1.52 1.52h3.73c.16 0 .29-.13.29-.29v-1.05c0-.14-.12-.26-.26-.26H3.63c-.14 0-.25-.11-.25-.25v-.52c0-2.31 1.88-4.19 4.19-4.19h.46c.34-.57.77-1.07 1.25-1.5-.33-.06-.68-.1-1.03-.1H7.56Z"
      fill={color}
    />
  </Svg>
)

export default LeadsOutlined
